import {
  INVOICE_DETAIL,
  INVOICE_DETAIL_SUCCESS,
  INVOICE_DETAIL_ERROR,
  INVOICE_SELECT,
  INVOICE_SELECT_SUCCESS,
  INVOICE_SELECT_ERROR,
  INVOICE_UPDATE,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_UPDATE_ERROR,
} from "./actionTypes"

const initialState = {
  responseDetail: null,
  loadingDetail: false,
  errorDetail: "",
  responseSelect: null,
  loadingSelect: false,
  errorSelect: "",
  responseUpdate: null,
  loadingUpdate: false,
  errorUpdate: "",
}

const Invoice = (state = initialState, action) => {
  switch (action.type) {
    case INVOICE_DETAIL:
      state = {
        ...state,
        responseDetail: null,
        loadingDetail: true,
        errorDetail: "",
        responseSelect: null,
        responseUpdate: null,
      }
      break
    case INVOICE_DETAIL_SUCCESS:
      const data = {...action.payload.data}
      for (let i = 0; i < data.response.invoiceData.transactions.length; i++) {
        const vatRate = data.response.invoiceData.transactions[i].vatRate
        const account = data.response.invoiceData.transactions[i].account
        data.response.invoiceData.transactions[i].vatRate = {value: vatRate, label: vatRate + "%"}
        data.response.invoiceData.transactions[i].account = {value: account, label: account}
      }
      state = {
        ...state,
        responseDetail: data,
        loadingDetail: false,
      }
      break
    case INVOICE_DETAIL_ERROR:
      state = {
        ...state,
        loadingDetail: false,
        errorDetail: action.payload,
      }
      break
    case INVOICE_SELECT:
      state = {
        ...state,
        loadingSelect: true,
        errorSelect: "",
      }
      break
    case INVOICE_SELECT_SUCCESS:
      const rd = state.responseDetail
      for (let i = 0; i < rd.response.invoiceData.transactions.length; i++) {
        action.payload.data.response.select.accounts.forEach((account) => {
          if (rd.response.invoiceData.transactions[i].account.value === account.value) {
            rd.response.invoiceData.transactions[i].account.label = account.label
          }
        })
      }
      state = {
        ...state,
        loadingSelect: false,
        responseSelect: action.payload.data,
        responseDetail: rd,
      }
      break
    case INVOICE_SELECT_ERROR:
      state = {
        ...state,
        loadingSelect: false,
        errorSelect: action.payload
      }
      break
    case INVOICE_UPDATE:
      state = {
        ...state,
        loadingUpdate: true,
        errorUpdate: "",
      }
      break
    case INVOICE_UPDATE_SUCCESS:
      state = {
        ...state,
        responseUpdate: action.payload.data,
        loadingUpdate: false,
      }
      break
    case INVOICE_UPDATE_ERROR:
      state = {
        ...state,
        loadingUpdate: false,
        errorUpdate: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Invoice
